import { createSlice } from '@reduxjs/toolkit';

export enum ModalType {
  SUCCESS = 'SUCCESS',
  DELETE = 'DELETE',
  ATTENTION = 'ATTENTION',
  LOG_OUT = 'LOG_OUT',
  MOVE = 'MOVE',
  ASSIGN = 'ASSIGN',
}

const initialSuccessModalParams = {
  modalType: ModalType.SUCCESS,
  title: '',
  onClickSuccess: () => {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    isModalOpen: false,
    modalParams: initialSuccessModalParams,
  },
  reducers: {
    showModal: (state, action) => {
      state.modalParams = action.payload;
      state.isModalOpen = true;
    },
    closeModal: state => {
      state.modalParams = initialSuccessModalParams;
      state.isModalOpen = false;
    },
  },
});

export const { showModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
